import React from 'react';

import { Stream } from '$partials/modules';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ContactPage}
 */
const ContactPage = (props) => {
    const page = props.data.page;

    return (
        <main className='container'>
            {/* Hero image */}
            {(page.heroImage || page.heroVideo) &&
                <div className='mb5 md-mb9'>
                    <div
                        className='width-100vw trunk-full-width mtn-6 sm-mtn-5 md-mtn-9'>
                        <figure>
                            {page.heroVideo ? (
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    src={page.heroVideo.videoUrl}
                                    width={'100%'}/>
                            ) : (
                                <Image {...page.heroImage} />
                            )}
                        </figure>
                    </div>
                    {page.heroCaption && (
                        <figcaption className='col-12 md-col-8 mt4'>
                            <p className='type-style-7'>
                                {page.heroCaption}
                            </p>
                        </figcaption>
                    )}
                </div>
            }

            <div className='col-12 flex flex-wrap mb6 sm-mb9'>
                <div className='col-12'>
                    <p className='type-style-5 pb5 md-pb4'>
                        {page.pageLabel}
                    </p>
                </div>
                <div className='col-12 sm-col-6 md-col-5 pb5 sm-pb0'>
                    <h1 className='type-style-1'>
                        {page.title}
                    </h1>
                </div>
                <div className='hide md-show col-1'/>
                <div
                    className='col-12 sm-col-6 md-col-4 rich-text type-style-3'
                    dangerouslySetInnerHTML={{__html: page.standfirst}}/>
            </div>

            {/* modules */}
            <Stream
                hubspot={props.hubspot}
                modules={page.modules}
                namespace='contact-page'
                offMarketForm={props.data.offMarketForm}
                page={page}
                {...props.data} />
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ContactPage ;
